<div *ngIf="emptyResult" [ngClass]="dialogOption ? 'dialog-option' : ''">
    <div class="search-empty-state-block">
        <div class="empty-state-block-icon-container" [ngSwitch]="filterOption">
            <mat-icon
                *ngSwitchCase="filterOptionEnum.Cases"
                class="empty-state-block-icon"
                >work_off</mat-icon
            >
            <mat-icon
                *ngSwitchCase="filterOptionEnum.Claims"
                class="empty-state-block-icon"
                >work_off</mat-icon
            >
            <mat-icon
                *ngSwitchCase="filterOptionEnum.Users"
                class="empty-state-block-icon"
                >sentiment_very_dissatisfied</mat-icon
            >
            <mat-icon
                *ngSwitchCase="filterOptionEnum.ServiceProviders"
                class="empty-state-block-icon"
                >domain_disabled</mat-icon
            >
            <mat-icon
                *ngSwitchCase="filterOptionEnum.Clients"
                class="empty-state-block-icon"
                >sentiment_very_dissatisfied</mat-icon
            >

            <mat-icon *ngSwitchDefault="" class="empty-state-block-icon"
                >work_off</mat-icon
            >
        </div>
        <div class="empty-state-block-heading">
            No {{ filterOption }} for search criteria.
        </div>
        <div class="empty-state-block-subheading">
            Try different a search query.
        </div>
    </div>
</div>

<div *ngIf="!emptyResult" [ngClass]="dialogOption ? 'dialog-option' : ''">
    <div class="search-empty-state-block">
        <div class="empty-state-block-icon-container">
            <mat-icon class="empty-state-block-icon">search</mat-icon>
        </div>
        <div class="empty-state-block-heading">
            Search to view {{ filterOption }}.
        </div>
        <div class="empty-state-block-subheading" [ngSwitch]="filterOption">
            <ng-container *ngSwitchCase="filterOptionEnum.Clients">
                Search by: full name, email address, contact number, policy
                number.
            </ng-container>
            <ng-container *ngSwitchDefault
                >Get started by entering searchable text.</ng-container
            >
        </div>
    </div>
</div>
